import { render, staticRenderFns } from "./listRoulette.vue?vue&type=template&id=48f42a5c&"
import script from "./listRoulette.vue?vue&type=script&lang=js&"
export * from "./listRoulette.vue?vue&type=script&lang=js&"
import style0 from "./listRoulette.vue?vue&type=style&index=0&id=48f42a5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports